import { GridList } from '@sleepstation/components'
import { DIRECTION, LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import { mapIndexed } from 'ramda-adjunct'
import React from 'react'
import styled from 'styled-components'
import PortalLink from './PortalLink'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const renderPortalLinks = mapIndexed((link, idx) => (
  <li key={idx}>
    <PortalLink link={link} />
  </li>
))

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(GridList).attrs({
  direction: DIRECTION.VERTICAL,
  spacing: [
    LAYOUT_SPACING.LARGE,
    LAYOUT_SPACING.LARGE,
    LAYOUT_SPACING.XX_LARGE,
    LAYOUT_SPACING.XX_LARGE,
  ],
  align: LAYOUT_ALIGN.STRETCH,
  columns: [1, 1, 2],
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalLinks = ({ links }) => <Layout>{renderPortalLinks(links)}</Layout>

PortalLinks.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default PortalLinks
